export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormSuccessResult.vue?vue&type=template&id=0bd5e536&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/components/FormSuccessResult.vue?vue&type=template&id=0bd5e536&
// module id = 1072
// module chunks = 0